import { useState } from "react";

import { Box, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { v4 as uuid } from "uuid";

import constants from "../../assets/constants";
import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogMessage from "../ui/omniDialogMessage";
import DialogTitle from "../ui/omniDialogTitle";
import OmniTextField from "../ui/omniTextField";

const OmniUserInputDialog = props => {
  const {
    open,
    onClose,
    onAccept,
    dialogTitle = "User Input",
    dialogMessage = "",
    inputLabel = "Your Answer",
    inputPlaceholder = "Answer Here",
    okMessage = "Ok",
    cancelMessage = "Cancel",
    maxWidth = "xs",
    fullWidth = true,
    defaultValue = "",
    omniInputType = constants.omniImputType.number,
    unitsLabel = "",
  } = props;

  const [userInput, setUserInput] = useState(defaultValue);

  const onAcceptHandler = () => {
    //trim any formatting shit like a $ or ()
    onAccept(userInput);
  };

  const onCloseHandler = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={() => onCloseHandler}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogContent>
        {dialogMessage && <DialogMessage>{dialogMessage}</DialogMessage>}

        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "left",
          }}
        >
          {omniInputType === constants.omniImputType.text && (
            <OmniTextField
              label={inputLabel}
              type="textInput"
              variant="outlined"
              name={uuid()} //prevents AutoComplete Suggestions
              id={"displayName"}
              value={userInput}
              // rowCount={rows}
              // multiline={multiline}
              rowCount={7}
              multiline={true}
              onChange={event => {
                setUserInput(event.target.value);
              }}
              placeholder={inputPlaceholder}
            />
          )}
          {omniInputType === constants.omniImputType.number && (
            <OmniTextField
              label={inputLabel}
              type="textInput"
              variant="outlined"
              name={uuid()} //prevents AutoComplete Suggestions
              id={"displayName"}
              value={userInput}
              onChange={event => {
                event.target.value = event.target.value.replace(/[^0-9]/g, "");
                setUserInput(event.target.value);
              }}
              placeholder={inputPlaceholder}
            />
          )}
          {omniInputType === constants.omniImputType.currency && (
            <OmniTextField
              label={inputLabel}
              type="textInput"
              variant="outlined"
              name={uuid()} //prevents AutoComplete Suggestions
              id={"displayName"}
              value={userInput}
              onChange={event => {
                event.target.value = event.target.value.replace(/[^0-9]/g, "");
                setUserInput(event.target.value);
              }}
              placeholder={inputPlaceholder}
            />
          )}
          <Typography
            variant="h6"
            textAlign={"center"}
            sx={{ marginTop: "12px", marginLeft: "8px" }}
          >
            {unitsLabel}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        {cancelMessage && (
          <Button onClick={onCloseHandler} color="secondary" variant="contained">
            {cancelMessage}
          </Button>
        )}
        <Button
          disabled={!userInput}
          onClick={onAcceptHandler}
          color="secondary"
          variant="contained"
        >
          {okMessage}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OmniUserInputDialog;
